/** ISO 4217 codes. The value is the code, so it goes straight into Intl.NumberFormat. */
export enum CurrencyEnum {
  VND = 'VND',
  USD = 'USD',
}

/** Minor-unit digits shown and accepted. Amounts are stored in major units (dong, dollars). */
export const CURRENCY_DECIMALS: Record<CurrencyEnum, number> = {
  [CurrencyEnum.VND]: 0,
  [CurrencyEnum.USD]: 2,
};

/** A restaurant created without an explicit currency gets its country's. */
export function defaultCurrencyFor(countryCode: string | null | undefined): CurrencyEnum {
  return countryCode?.trim().toUpperCase() === 'VN' ? CurrencyEnum.VND : CurrencyEnum.USD;
}
